import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { Button, Card, Field } from '../ui.jsx';

export default function Settings({ notify }) {
  const [f, setF] = useState(null);

  useEffect(() => {
    api('/api/settings').then((d) => setF(d.settings));
  }, []);

  async function save(e) {
    e.preventDefault();
    try {
      const d = await api('/api/settings', { method: 'PUT', body: f });
      setF(d.settings);
      notify({ ok: true, msg: 'تم حفظ الإعدادات ✅' });
    } catch (e2) {
      notify({ ok: false, msg: e2.message });
    }
  }

  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <Card title="الإعدادات العامة">
      <form onSubmit={save}>
        <Field label="اسم المنصة" hint="يظهر في واجهة اللوحة">
          <input value={f.brand || ''} onChange={set('brand')} />
        </Field>

        <Field
          label="ملاحظة توضيحية"
          hint="نص يظهر أعلى نموذج البلاغ — وضّح أن البلاغ داخلي فقط"
        >
          <textarea
            rows={3}
            value={f.publicNote || ''}
            onChange={set('publicNote')}
            placeholder="مثال: البلاغ يُسجَّل داخل اللوحة ليراجعه الفريق."
          />
        </Field>

        <Button type="submit" variant="primary">
          حفظ الإعدادات
        </Button>
      </form>
    </Card>
  );
}
